/**
 * Sneakers is never a still image ([D-018](../../../docs/DECISIONS.md#d-018),
 * [Mascot](../../../docs/MASCOT.md#idle-and-ambient-motion), [D-139](../../../docs/DECISIONS.md#d-139)).
 *
 * When he blinks and where he looks, as numbers. The motion itself is CSS; this
 * is the part that has to be *random* without being *arbitrary*: a blink every
 * three to six seconds reads as alive, a blink on a fixed beat reads as a
 * machine, and a blink every half second reads as something wrong with him.
 */
/** A blink every 3–6 seconds, randomised, as the mascot spec says. */
export const BLINK_EVERY_MS = [3000, 6000];
/** How long the eyes are shut. Long enough to see, short enough to be a blink. */
export const BLINK_MS = 140;
/** An occasional look around: rarer than blinking, so it stays a glance. */
export const LOOK_EVERY_MS = [7000, 12000];
/** How long he holds a glance before looking back at the child. */
export const LOOK_MS = 1200;
const GLANCES = ['left', 'right', 'up'];
/** A wait somewhere in `[low, high]`, from a random number in `[0, 1)`. */
export const waitBetween = (range, random) => Math.round(range[0] + (range[1] - range[0]) * Math.min(Math.max(random, 0), 1));
/**
 * Which way to glance: never the same way twice running, because a mascot who
 * keeps looking left is looking *at* something.
 */
export function nextGlance(previous, random) {
    const choices = GLANCES.filter((glance) => glance !== previous);
    const at = Math.min(Math.floor(Math.max(random, 0) * choices.length), choices.length - 1);
    // `choices` always has two or three entries, so `at` always names one.
    return choices[at];
}
//# sourceMappingURL=idle.js.map